module.exports = __webpack_public_path__ + "static/img/login-img.e9f8bb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/login-img.png
// module id = jZ8B
// module chunks = 1